import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { IMNLogo, IWTLogo } from '@gemini/logos';
export const Logos = () => {
    return (_jsxs(Box, { marginTop: "spacing.12", display: { 'breakpoint.base': 'flex', 'breakpoint.lg': 'block' }, flexDirection: "column", gap: "spacing.12", children: [_jsx(IMNLogo, {}), " ", _jsx(IWTLogo, {})] }));
};
